import { computed } from 'vue'

import type { ComputedRef } from 'vue'
import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'

import { useAssignmentEditorStore } from './store'
import { useAssignmentTemplatesStore } from '../assignment-templates/store'

const DEFAULT_PER_PAGE = 25

interface HeaderAssignmentEditorReturn {
  refConfig: ComputedRef<LinkBreadcrumbItem[]>
}

export const getAssignmentListPath = (store: ReturnType<typeof useAssignmentTemplatesStore>): string => {
  const params = new URLSearchParams()

  if (store.getFilterSearch) params.set('search', store.getFilterSearch)
  if (store.getFilterType) params.set('type', store.getFilterType)
  if (store.getFilterDisciplineCode) params.set('discipline_code', store.getFilterDisciplineCode)
  if (store.getFilterGrade) params.set('grade', store.getFilterGrade)
  if (store.getFilterModuleId) params.set('curriculum_module_id', String(store.getFilterModuleId))
  if (store.getPerPage !== DEFAULT_PER_PAGE) params.set('per_page', String(store.getPerPage))
  if (store.getCurrentPage > 1) params.set('page', String(store.getCurrentPage))

  const query = params.toString()

  return query ? `${AppRoute.Assignments}?${query}` : AppRoute.Assignments
}

export const useHeaderAssignmentEditor = (): HeaderAssignmentEditorReturn => {
  const templatesStore = useAssignmentTemplatesStore()
  const editorStore = useAssignmentEditorStore()

  const refConfig = computed<LinkBreadcrumbItem[]>(() => [
    {
      id: 'assignment-templates',
      text: 'Assignment templates',
      to: getAssignmentListPath(templatesStore),
      disabled: false,
    },
    {
      id: 'assignment-template',
      // The catalogue title, once loaded; a neutral label while the document is still on its way.
      text: editorStore.getTitle || 'Assignment template',
      to: null,
      disabled: true,
    },
  ])

  return {
    refConfig,
  }
}
